import * as React from "react";
import Text from "@sproutsocial/seeds-react-text";
import { Icon } from "@sproutsocial/seeds-react-icon";
import { cn } from "./cn";
import type { TypeListItemContentProps } from "./ListItemTypes";

/**
 * Tailwind CSS implementation of ListItemContent. The Box layout scaffolding is
 * expressed through semantic `seeds-list-item-content*` classes from list.css
 * (no runtime CSS-in-JS). Text and Icon remain as primitives — the spacing they
 * previously received via system props (Icon mr, Byline mt) is now applied by
 * the parent classes so those primitives stay on their own static paths.
 */
const ListItemContentTailwind = ({
  text,
  details,
  aside,
  iconName,
  iconLabel,
  actions,
  className,
  ...rest
}: TypeListItemContentProps) => {
  return (
    <div
      className={cn("seeds-list-item-content", className)}
      {...(rest as React.HTMLAttributes<HTMLDivElement>)}
    >
      <div className="seeds-list-item-content-main">
        {iconName && (
          <span className="seeds-list-item-content-icon">
            <Icon name={iconName} size="small" ariaLabel={iconLabel} />
          </span>
        )}
        <div className="seeds-list-item-content-text">
          <Text.SmallSubHeadline as="div">{text}</Text.SmallSubHeadline>
          {details && (
            <Text.Byline as="div" className="seeds-list-item-content-details">
              {details}
            </Text.Byline>
          )}
        </div>
      </div>
      <div className="seeds-list-item-content-aside">
        {aside && <Text.Byline as="div">{aside}</Text.Byline>}
        {actions && (
          <div className="seeds-list-item-content-actions">{actions}</div>
        )}
      </div>
    </div>
  );
};

ListItemContentTailwind.displayName = "ListItemContent";

export default ListItemContentTailwind;
